import React from 'react'
import COLOR_PALETTE from 'constants/color-palette'
import { withRadium } from 'higher-order-components'

class InputRadio extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.checked || false
    }
  }

  handleClick = () => {
    this.setState({
      checked: !this.state.checked
    }, () => {
      this.props.handleOnClick && this.props.handleOnClick()
    })
  }

  componentWillReceiveProps(newProps){
    this.setState({
      checked: newProps.checked
    })
  }

  render() {
    const { handleOnClick, name, checked, label } = this.props

    return (
      <div style={styles.main} onClick={this.handleClick}>
        <input
          name={this.props.name}
          type="radio"
          style={styles.input}
          checked={this.state.checked ? 'checked' : ''}
          value={this.state.checked} />
        <label htmlFor={this.props.name} key="label" style={styles.label}>
          <span> {this.props.label} </span>
        </label>
        {!this.state.checked && (
          <div style={styles.unchecked}>
            <div style={styles.insideUnChecked} />
          </div>
        )}
        {this.state.checked && (
          <div style={styles.checked}>
            <div style={styles.insideChecked} />
          </div>
        )}
      </div>
    )
  }
}

export default withRadium()(InputRadio)

const styles = {
  main: {
    position: 'relative',
    flexGrow: 1,
    flexDirection: 'row',
    display: 'flex',
    margin: '0.5em 1em 0.5em 0px'
  },
  label: {
    display: 'block',
    lineHeight: '1.25em',
    position: 'relative',
    padding: '0 0 0 2em',
    margin: '0px auto',
    zIndex: 10,
    cursor: 'pointer',
    width: '100%'
  },
  unchecked: {
    display: 'block',
    position: 'absolute',
    border: `2px solid ${COLOR_PALETTE.GRAY}`,
    borderRadius: '100%',
    height: '1em',
    width: '1em',
    top: '0',
    left: '0',
    zIndex: '5',
    transition: 'border .25s linear',
    ':hover': {
      border: '5px solid #FFFFFF'
    }
  },
  insideUnChecked: {},
  checked: {
    display: 'block',
    position: 'absolute',
    border: `2px solid ${COLOR_PALETTE.GRAY}`,
    borderRadius: '100%',
    height: '1em',
    width: '1em',
    top: '0',
    left: '0',
    zIndex: '5',
    transition: 'border .25s linear',
    ':hover': {
      border: '5px solid #FFFFFF'
    }
  },
  insideChecked: {
    backgroundColor: `${COLOR_PALETTE.RED}`,
    width: '0.5em',
    height: '0.5em',
    position: 'absolute',
    top: '25%',
    left: '25%',
    borderRadius: '100%'
  },
  input: {
    position: 'absolute',
    visibility: 'hidden',
    width: '0px',
    height: '0px'
  }
}



// WEBPACK FOOTER //
// ./src/components/form-elements/input-radio/index.jsx